import { useEffect, useMemo } from 'react';
import {
	SHOULD_SHOW_WELCOME_ONBOARDING_MODAL,
	SHOWED_WELCOME_ONBOARDING_MODAL_DURING_SIGNUP,
} from '@atlassian/jira-onboarding-core/src/constants.tsx';
import { sessionStorageProvider } from '@atlassian/jira-onboarding-core/src/utils/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { ModalSource } from '../../common/types.tsx';
import { useCanShowNudgeTour } from '../../common/use-can-show-nudge-tour.tsx';

export const useShouldShowModalBasedOnSessionStorage = () => {
	const shouldShowModalBasedOnSessionStorage = useMemo(() => {
		if (
			fg('jira_project_onboarding_wizard_during_signup_gate') ||
			fg('jira_project_wizard_for_scrum_gate') ||
			fg('jira_software_kanban_wizard_m2_gate')
		) {
			const isWizardDuringSignup = sessionStorageProvider.get(
				SHOWED_WELCOME_ONBOARDING_MODAL_DURING_SIGNUP,
			);
			if (isWizardDuringSignup) {
				return false;
			}
		}

		const sessionStorageVal = sessionStorageProvider.get(SHOULD_SHOW_WELCOME_ONBOARDING_MODAL);

		if (sessionStorageVal === undefined) {
			return false;
		}

		return true;
	}, []);

	useEffect(() => {
		// Remove the session storage value to prevent the modal showing again
		sessionStorageProvider.remove(SHOULD_SHOW_WELCOME_ONBOARDING_MODAL);
	}, []);

	return shouldShowModalBasedOnSessionStorage;
};

export const useShouldShowWelcomeModal = (source: ModalSource) => {
	const canShowNudgeTour = useCanShowNudgeTour();
	const sessionStorageVal = useMemo(
		() => sessionStorageProvider.get(SHOULD_SHOW_WELCOME_ONBOARDING_MODAL),
		[],
	);

	if (
		fg('jira_project_onboarding_wizard_during_signup_gate') ||
		fg('jira_project_wizard_for_scrum_gate') ||
		fg('jira_software_kanban_wizard_m2_gate')
	) {
		const isWizardDuringSignup = sessionStorageProvider.get(
			SHOWED_WELCOME_ONBOARDING_MODAL_DURING_SIGNUP,
		);
		if (isWizardDuringSignup) {
			return false;
		}
	}

	if (sessionStorageVal === undefined) {
		return false;
	}

	return canShowNudgeTour(source);
};
